import { InstrucaoType } from "../../admin/hooks/useUtils";

export default function compareInstrucaoCan(
  id: string | undefined,
  instrucoes: InstrucaoType[]
) {
  if (!instrucoes) {
    return;
  }
  const itemEncontrado = instrucoes.find((item) => item.instrucao_codigo == id);

  if (itemEncontrado) {
    return itemEncontrado?.instrucao_descricao;
  } else {
    return null;
  }
}
